import React, { useCallback, useEffect } from 'react';

import cookies from 'common/utils/cookies';

import { logOut } from '../../../packages/common/api';

const LogoutContainer = () => {
  const handleLogout = useCallback(async () => {
    // Очистка LocalStorage
    localStorage.clear();

    // Очистка SessionStorage
    sessionStorage.clear();

    // Очистка cookies
    document.cookie.split(';').forEach(cookie => {
      const name = cookie.split('=')[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    await logOut();
    // cookies.removeCookie({
    //   key: 'access_token',
    //   host: `${window.location.protocol}//${window.location.hostname}`,
    // });

    window.location.href = '/login';
  }, []);

  useEffect(handleLogout, [handleLogout]);

  return <></>;
};

export default LogoutContainer;
